import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { SidenavItem } from 'src/app/shared/interfaces/sidenav-item.interface';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigationComponent extends BaseComponent implements OnInit, AfterViewInit {

  public sidenavItems$ = this._sidenavService.items$;
  public currentlyOpen$ = this._sidenavService.currentlyOpen$;
  public showMoreButtonAfterIndex = 8;

  @ViewChild('overflowContainer') public overflowContainer: ElementRef;

  constructor(
    private _sidenavService: SidenavService,
    @Inject(DOCUMENT) private _document: Document,
    private _cd: ChangeDetectorRef,
    private _router: Router
  ) {
    super();
  }

  ngOnInit() {}

  handleClick(item: SidenavItem) {
    if (item.subItems && item.subItems.length > 0) {
      this._sidenavService.toggleItemOpen(item);
    } else if (typeof item.routeOrFunction === 'string' || item.routeOrFunction instanceof String) {
      this._router.navigate([item.routeOrFunction]);
    } else if (typeof item.routeOrFunction === 'function' || item.routeOrFunction instanceof Function) {
      item.routeOrFunction();
    } else {
      throw Error('Could not determine what to do, Sidenav-Item has no routeOrFunction set AND does not contain any subItems');
    }
  }

  ngAfterViewInit(): void {
  }
}
